module.exports = __webpack_public_path__ + "media/images/emblems/Ermensee_LU-6e9d868c25eaf46c12481143e7dd6e0e.png";